import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";
import { ICardProperty } from "@rf-model/card-property.model";
import { getConditionStatusLabel } from "@/src-refactor/modules/shared/components/refactor/helpers/property/prepare-condition-status-label";
import { prepareDetailPropertyCardTitle } from "./detail/prepareDetailPropertyCardTitle";
import { prepareDetailPropertyCardBusinessType } from "./detail/prepareDetailPropertyCardBusinessType";
import { prepareDetailPropertyCardPictures } from "./detail/prepareDetailPropertyCardPictures";
import { prepareDetailPropertyCardPrice } from "./detail/prepareDetailPropertyCardPrice";
import { prepareDetailPropertyCardFeatures } from "./detail/prepareDetailPropertyCardFeatures";
import { prepareDetailPropertyCardLocation } from "./detail/prepareDetailPropertyCardLocation";
import { prepareDetailPropertyCardAgents } from "./detail/prepareDetailPropertyCardAgents";
import { prepareDetailPropertyCardStatus } from "./detail/prepareDetailPropertyCardStatus";

const propertyDetailToCardAdapter = (
  property: IPropertyDetailsResponse
): ICardProperty => {
  const businessType = prepareDetailPropertyCardBusinessType(property);
  const title = prepareDetailPropertyCardTitle(property);
  const pictures = prepareDetailPropertyCardPictures(property);
  const budget = prepareDetailPropertyCardPrice(property);
  const feature = prepareDetailPropertyCardFeatures(property);
  const location = prepareDetailPropertyCardLocation(property);
  const agents = prepareDetailPropertyCardAgents(property);
  const status = prepareDetailPropertyCardStatus(property);
  const conditionStatus = getConditionStatusLabel(
    property.condition_status,
    businessType
  );
  return {
    id: property.id,
    title,
    conditionStatus,
    businessType,
    pictures,
    prices: budget,
    feature: feature,
    views: property.views_counter,
    likes: property.likes_counter,
    agents,
    status,
    commissionGaranted: property.total_comission ?? 0,
    nameProperty: property.name ?? "",
    location: location
  };
};

export default propertyDetailToCardAdapter;
